export default __webpack_public_path__ + "static/media/onboarding-bg.683a6130.png";